import React from "react"
import lodash from "lodash"

const PrinterContext = React.createContext({
  printers: {},
  currentPrinter: 0,
  changePrinter: lodash.noop
})

export default PrinterContext
